import { Component } from '@angular/core';

import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-file-path',
  styleUrls: ['form-file-path.component.scss'],
  templateUrl: 'form-file-path.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormFieldErrorComponent,
  ],
})
export class FormFilePathComponent extends FieldBaseComponent {}
